/* istanbul ignore file */

import { Field } from '../services/logic-services/models';

export class FilterMenuOptions {
    selectedFields: Field[] = [];
    filterValues: { [key: string]: (Date | boolean | number | string)[]; } = {};
    allFields: Field[] = [];
}
